<template>
  <div>
    <div class="page-hero">
      <div class="container">
        <span class="section__label">Демо</span>
        <h1 class="page-hero__title">Демо-доступ на 14 дней</h1>
        <p class="page-hero__text">Заполните форму — настроим систему под ваши формулы за вас и проведём встречу-разбор. Это бесплатно.</p>
      </div>
    </div>

    <section class="section">
      <div class="container demo-layout">
        <div class="demo-form-wrap">
          <h2 class="demo-form-wrap__title">Запросить демо-доступ</h2>
          <form class="demo-form" @submit.prevent="submit">
            <!-- honeypot: настоящие пользователи это поле не видят -->
            <input v-model="form.website" type="text" name="website" tabindex="-1" autocomplete="off" class="hp-field" />
            <div class="form-group">
              <label>Имя и фамилия *</label>
              <input v-model="form.name" type="text" placeholder="Иван Петров" required />
            </div>
            <div class="form-group">
              <label>Рабочий email *</label>
              <input v-model="form.email" type="email" placeholder="ivan@company.ru" required />
            </div>
            <div class="form-group">
              <label>Телефон *</label>
              <input v-model="form.phone" type="tel" placeholder="+7 (999) 000-00-00" required />
            </div>
            <div class="form-group">
              <label>Название компании *</label>
              <input v-model="form.company" type="text" placeholder="ООО Ромашка" required />
            </div>
            <div class="form-group">
              <label>Количество сотрудников</label>
              <select v-model="form.size">
                <option value="">Выберите</option>
                <option>до 30</option>
                <option>30–100</option>
                <option>100–500</option>
                <option>500+</option>
              </select>
            </div>
            <div class="form-group">
              <label>Как считаете премии сейчас?</label>
              <select v-model="form.calc_method">
                <option value="">Выберите</option>
                <option>Excel / Google Таблицы</option>
                <option>1С</option>
                <option>Самописная система</option>
                <option>Вручную</option>
                <option>Другое</option>
              </select>
            </div>
            <div class="form-group">
              <label>Комментарий</label>
              <textarea v-model="form.comment" placeholder="Расскажите о вашей задаче..." rows="3" />
            </div>
            <base-button size="lg" style="width:100%; justify-content:center;" :disabled="sending || sent">
              {{ sent ? 'Заявка отправлена ✓' : (sending ? 'Отправляем…' : 'Отправить заявку') }}
            </base-button>
            <p v-if="error" class="demo-form__error">{{ error }}</p>
            <p v-if="sent" class="demo-form__success">
              Спасибо! Заявка принята{{ bookingEnabled ? '.' : ' — свяжемся с вами в течение рабочего дня, чтобы назначить встречу-разбор.' }}<br/>
              Ваш номер телефона уже получил <strong>14 дней демо-доступа</strong> к системе.
              Войдите через <a href="https://app.candb.pro/login/" target="_blank" rel="noopener">app.candb.pro</a>.
            </p>
            <booking-picker
              v-if="sent && bookingEnabled"
              :name="form.name"
              :phone="form.phone"
              :email="form.email"
              :comment="form.comment"
              :api-base="apiBase"/>
            <p class="demo-form__note">
              Нажимая кнопку, вы соглашаетесь с
              <router-link to="/policy">политикой конфиденциальности</router-link>.
            </p>
          </form>
        </div>

        <div class="demo-info">
          <h3 class="demo-info__title">Как пройдёт демо</h3>
          <ul class="demo-info__list">
            <li v-for="item in demoItems" :key="item">{{ item }}</li>
          </ul>
          <div class="demo-info__contact">
            <p>Или напишите нам напрямую:</p>
            <a href="mailto:info@candb.pro">info@candb.pro</a>
          </div>
          <div class="demo-info__contact">
            <p>Как система работает изнутри — короткие разборы в канале:</p>
            <a href="https://t.me/candbpro" target="_blank" rel="noopener">Канал в Telegram →</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseButton from '../components/ui/BaseButton.vue'
import BookingPicker, { bookingConfigured } from '../components/BookingPicker.vue'
import { reachGoal } from '../analytics'
export default {
  name: 'DemoPage',
  components: { BaseButton, BookingPicker },
  data() {
    return {
      bookingEnabled: bookingConfigured(),
      sent: false,
      sending: false,
      error: '',
      form: { name: '', email: '', phone: '', company: '', size: '', calc_method: '', comment: '', website: '' },
      demoItems: [
        'Встреча-разбор (30 минут): как вы считаете премии сейчас',
        'Настроим систему под ваши формулы — за вас',
        'Посчитаем ваш реальный период на ваших данных',
        'Покажем KPI-карту и онлайн-оценку премии сотруднику',
        'Сверим итог с вашим расчётом в Excel',
        'Выгрузим ведомость для бухгалтерии',
        'Ответы на ваши вопросы',
      ],
    }
  },
  computed: {
    apiBase() {
      return (process.env.VUE_APP_API_BASE || 'https://app.candb.pro/').replace(/\/?$/, '/')
    },
  },
  methods: {
    getUtm() {
      try {
        return JSON.parse(localStorage.getItem('utm_params') || '{}')
      } catch (e) {
        return {}
      }
    },
    async submit() {
      this.error = ''
      this.sending = true
      try {
        const apiBase = this.apiBase
        const res = await fetch(apiBase + 'core/api/leads/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...this.form, source: 'demo', utm: this.getUtm() }),
        })
        if (res.status === 202 || res.ok) {
          if (this.form.phone) {
            await fetch(apiBase + 'users/trial/', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ phone: this.form.phone }),
            }).catch(() => {})
          }
          this.sent = true
          reachGoal('lead_submit')
        } else {
          let body = {}
          try { body = await res.json() } catch (e) {}
          this.error = body.detail || 'Не удалось отправить заявку. Попробуйте позже или напишите на info@candb.pro.'
        }
      } catch (e) {
        this.error = 'Сеть недоступна. Попробуйте позже или напишите на info@candb.pro.'
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.page-hero {
  background: linear-gradient(135deg, #1E3A8A, #2563EB);
  color: white;
  padding: 140px 0 80px;
}
.page-hero__title { font-size: 2.5rem; font-weight: 800; margin: 12px 0 16px; }
.page-hero__text { font-size: 1.125rem; opacity: 0.85; max-width: 520px; }

.demo-layout {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 64px;
  align-items: start;
}
.demo-form-wrap__title { font-size: 1.5rem; font-weight: 700; margin-bottom: 28px; }
.demo-form { display: flex; flex-direction: column; gap: 20px; }
.form-group { display: flex; flex-direction: column; gap: 6px; }
.form-group label { font-size: 0.875rem; font-weight: 600; color: var(--dark); }
.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 14px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.9375rem;
  font-family: inherit;
  color: var(--dark);
  transition: var(--transition);
  background: white;
}
.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
}
.demo-form__note { font-size: 0.8125rem; color: var(--gray); text-align: center; }
.demo-form__note a { color: var(--primary); text-decoration: none; }
.demo-form__note a:hover { text-decoration: underline; }
.demo-form__error {
  background: #FEF2F2; border: 1px solid #FECACA; color: #B91C1C;
  padding: 10px 14px; border-radius: var(--radius-sm); font-size: 0.9375rem;
}
.demo-form__success {
  background: #ECFDF5; border: 1px solid #A7F3D0; color: #065F46;
  padding: 12px 14px; border-radius: var(--radius-sm); font-size: 0.9375rem;
  line-height: 1.55;
}
.demo-form__success a { color: #047857; font-weight: 600; }
.hp-field { position: absolute !important; left: -9999px !important; width: 1px !important; height: 1px !important; opacity: 0; }

.demo-info {
  background: var(--light);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 36px 32px;
  position: sticky;
  top: 100px;
}
.demo-info__title { font-size: 1.25rem; font-weight: 700; margin-bottom: 20px; }
.demo-info__list { list-style: none; display: flex; flex-direction: column; gap: 12px; margin-bottom: 32px; }
.demo-info__list li {
  font-size: 0.9375rem; color: var(--dark);
  padding-left: 24px; position: relative; line-height: 1.5;
}
.demo-info__list li::before { content: '✓'; position: absolute; left: 0; color: var(--secondary); font-weight: 700; }
.demo-info__contact p { font-size: 0.875rem; color: var(--gray); margin-bottom: 6px; }
.demo-info__contact a { font-weight: 600; font-size: 0.9375rem; }

@media (max-width: 900px) {
  .demo-layout { grid-template-columns: 1fr; }
  .demo-info { position: static; }
  .page-hero__title { font-size: 1.875rem; }
}
</style>
